module.exports = __webpack_public_path__ + "img/307.12a45007.png";